import React, { useEffect, useState } from 'react';
import { Image, ImageStyle, StyleProp, ImageResizeMode } from 'react-native';
import DownloadManager from '../../../utils/DownloadManager';

type OfflineImageProps = {
  source: number | { uri: string };
  resizeMode?: ImageResizeMode;
  style?: StyleProp<ImageStyle> | StyleProp<ImageStyle>[];
  className?: string; // For Tailwind class names
};

const OfflineImage: React.FC<OfflineImageProps> = ({
  source,
  resizeMode = 'contain',
  style = {},
  className,
}) => {
  const [imageUri, setImageUri] = useState<number | { uri: string } | null>(
    null,
  );

  useEffect(() => {
    let isMounted = true;

    const getImageAsync = async () => {
      if (typeof source === 'number') {
        setImageUri(source); // Local resource via require
        return;
      }

      if (!isMounted) {
        return;
      }

      const image = await DownloadManager.getFileUri(source.uri);
      if (isMounted) {
        setImageUri({ uri: image });
      }
    };

    getImageAsync();

    return () => {
      isMounted = false;
    };
  }, [source]);

  return (
    <Image
      source={imageUri ?? undefined}
      resizeMode={resizeMode}
      style={style}
      className={className}
    />
  );
};

export default OfflineImage;
